module.exports = __webpack_public_path__ + "static/media/hi.3a8b9eca.png";